import { useMemo } from 'react';
import { Edit, Form, Toolbar, useEditController } from 'react-admin';
import { CardContent } from '@mui/material';
import type { AntennaSummary } from '@wwf/sdk';
import { AntennaInputs } from './AntennaInputs';
import { antennaSummaryToInput } from '@domain/antenna/antenna';

export const AntennaEdit = () => {
    const { record } = useEditController<AntennaSummary>();
    const formRecord = useMemo(
        () => (record ? antennaSummaryToInput(record) : undefined),
        [record]
    );

    return (
        <Edit
            actions={false}
            redirect="show"
            mutationMode="pessimistic"
            transform={values => {
                // add https:// before website if not present
                if (values.website && !values.website.startsWith('http')) {
                    values.website = `https://${values.website}`;
                }
                return values;
            }}
        >
            <Form record={formRecord}>
                <CardContent>
                    <AntennaInputs />
                </CardContent>
                <Toolbar />
            </Form>
        </Edit>
    );
};
